module.exports = __webpack_public_path__ + "static/media/adventureEssentialsIcon.dfcc0eb4.png";